// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#import-progress[data-v-18d8e2ac] {\n  display: inline-block;\n}\n.input-select-file[data-v-18d8e2ac] {\n  width: 0px;\n  visibility: hidden;\n}\n.btn-upload[data-v-18d8e2ac] {\n  margin-bottom: 0px;\n}\n.btn-upload[data-v-18d8e2ac]:disabled {\n  cursor: not-allowed;\n  background-color: #ccc;\n}", ""]);
// Exports
module.exports = exports;
